import React from 'react'
import Label from 'src/components/riders/rider-portal/common/Label'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

interface IFareAndPriceProps {
  fare: number
  price: number
}

const FareAndPrice = ({ fare, price }: IFareAndPriceProps) => {
  const { fare: fareLabel, price: priceLabel } = RIDER_PORTAL_UI_MESSAGES.common
  return (
    <div>
      <h4 className='font-black3 font-medium rp-mb8 rp-my0 text-center text-md'>{`${fareLabel} and ${priceLabel}`}</h4>
      <div className='flex column-gap-12'>
        <Label text={fareLabel} />
        <p className='font-grey8 rp-my0 rp-pt2 text-md'>{`$${(fare / 100).toFixed(2)}`}</p>
      </div>
      <div className='flex column-gap-12 rp-mt8'>
        <Label text={priceLabel} />
        <p className='font-grey8 rp-my0 rp-pt2 text-md'>{`$${(price / 100).toFixed(2)}`}</p>
      </div>
    </div>
  )
}

export default FareAndPrice



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/details/FareAndPrice.tsx